import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { GridPattern, Orbs } from './DecorativeElements';
import './AboutPreview.css';

const AboutPreview = () => {
  const [ref, inView] = useInView({
    threshold: 0.2,
    triggerOnce: true,
  });

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.8,
        ease: [0.25, 0.1, 0.25, 1],
      },
    },
  };

  return (
    <section className="about-preview-section" ref={ref}>
      <GridPattern />
      <Orbs />
      <div className="container">
        <motion.div
          className="about-preview-content"
          variants={containerVariants}
          initial="hidden"
          animate={inView ? 'visible' : 'hidden'}
        >
          <motion.div className="section-label" variants={itemVariants}>
            What defines us
          </motion.div>

          <motion.h2 className="section-title-large" variants={itemVariants}>
            We nurture your brands like we treat our people:<br />
            with <span className="highlight-creativity">creativity</span> and <span className="highlight-compassion">compassion</span>.
          </motion.h2>

          <motion.div className="values-showcase" variants={itemVariants}>
            <div className="value-item">
              <div className="value-icon">✨</div>
              <h3>Creativity</h3>
              <p>We push boundaries and explore new possibilities in every project.</p>
            </div>
            <div className="value-item">
              <div className="value-icon">❤️</div>
              <h3>Compassion</h3>
              <p>We care deeply about your success and treat your brand as our own.</p>
            </div>
          </motion.div>

          <motion.div className="section-content" variants={itemVariants}>
            <p className="lead-text">
              <strong>We're brand builders at heart, creators by design, tech enthusiasts in practice, and integrated at our core.</strong>
            </p>
            <p>
              We're on a mission to take the very best of Indian creative talent to the world. Driven by a ferocious hunger 
              to create tangible impact for your business, we work with in-house specialists, industry partners and technology 
              leaders to push the boundaries of creativity and put your brand on the global stage.
            </p>
            <motion.div
              className="link-wrapper"
              whileHover={{ x: 10 }}
            >
              <Link to="/about" className="link-arrow">
                Dive into our culture <ArrowRight size={20} />
              </Link>
            </motion.div>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};

export default AboutPreview;
